module.exports = {
  NONE: "none",
  VALENTINES: "valentines", // 1 February - 15 February
  PATRICK: "patrick", // 10 March - 18 March
  EASTER: "easter", // 29 March - 6 April 2021
  EUROS: "euros", // 9 June - 19 June 2021
  SUMMER: "summer", // 20 June - 27 June
  WIMBLEDON: "wimbledon", // 28 June - 12 July 2021
  OLYMPICS: "olympics", // 20 July - 9 Aug 2021
  HALLOWEEN: "halloween", // 20 Oct - 1 Nov
  GUY_FAWKES: "guyfawkes", // 3 Nov - 6 Nov
  CHRISTMAS: "christmas", // 15 Dec - 27 Dec
  PARALYMPICS: "paralympics", // 23 Aug - 5 Sep
  JUBILEE: "jubilee", // 2 June - 5 June
};
